<script setup>
import { inject, computed } from 'vue';
import { GROUP_TYPE } from 'src/utils/config';
import MButton from 'src/components/MButton/index.vue';
import { useIns } from 'src/utils/v2_helper/common';
import Receipt from '../components/Receipt.vue';
import HeadTile from '../../result/components/HeadTitle.vue';
import CompletedVue from '../../result/Completed.vue';

const app = useIns();

const order = inject('orderData');

const tableNumber = computed(() => order.value?.orderDetail?.tableNumber);

const tableSize = computed(() => {
  const len = order.value?.orderDetail?.tableNumber?.length || 0;
  return len > 10 ? 24 : 36;
});
</script>

<template>
  <div class="cashw">
    <div class="cashw-top">
      <div class="cashw-top_core">
        <div class="cashw-top-tile" bold>{{ $t('fullDinein.waitPay') }}</div>
        <div class="cashw-top-msg" break>{{ $t('fullDinein.cashWaitMsg') }}</div>
        <div
          class="cashw-top-submsg"
          break
          bold
          :style="{ 'font-size': `${tableSize}px` }"
        >{{ tableNumber }}</div>
        <div class="cashw-top-subtile">{{ $t('fullDinein.tableNumber') }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.cashw {
  position: relative;
  background: url('~src/assets/images/result/successBg.png') no-repeat center 0;
  background-size: cover;
  padding-bottom: 40px;
  &-top {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 370px;
    &_core {
      text-align: center;
      margin: 0 30px;
      div + div {
        line-height: 1.2;
        margin-top: 10px;
      }
    }
    &-tile {
      color: #ff9e2d;
      font-size: 20px;
    }
    &-msg {
      color: #6b7280;
    }
    &-subtile {
      color: #9ca3af;
    }
    &-submsg {
      font-size: 36px;
      color: $black;
    }
  }
}
</style>
